import Wareops from './wareops';

export default [
  {
    path: '/wareops',
    title: '',
    component: Wareops,
  },
];
